export { TherapyPage } from "./TherapyPage"
